export default {
      id: "notifications__drain-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__drain",
      toString: function () {
        return this.url;
      }
    }